/* tslint:disable:no-shadowed-variable */
/* eslint-disable no-shadow */
import {Injectable} from '@angular/core';
import {confirm} from 'devextreme/ui/dialog';
import {State as activePublicationState} from '../active-publication.reducers';
import {TranslateService} from '@ngx-translate/core';
import { from } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class PublicationIntegrityService {

  constructor(private translator: TranslateService) {
  }

  extProfilsIntegrityTest(newList: string[], activePublication: activePublicationState) {

    // console.log('[extProfilsIntegrityTest]');

    //
    //
    //
    const promiseResult = ({newList, activePublication: activePublicationState}) => {
      //
      //
      //
      return new Promise((resolve, reject) => {

        try {

          //
          // Détermine ce qui a changé.
          //
          // Check if profiling exists and has selectedProfiles
          if (!activePublication.datas.profiling || !activePublication.datas.profiling.selectedProfiles) {
            // If profiling is not initialized, just resolve with newList
            resolve(newList);
            return;
          }

          const currentSelectedProfiles = activePublication.datas.profiling.selectedProfiles;

          //
          // Détermine ce qui a changé.
          //
          // 1. On ajoute : tout est beau :)
          //
          if (newList.length > currentSelectedProfiles.length) {
            resolve(newList);
          }
          //
          // 2. On retire : on teste l'usage....
          //
          if (newList.length < currentSelectedProfiles.length) {
            // console.log('Retire de la liste...');
            // On trouve la différence :
            const newKey = currentSelectedProfiles.filter((x) => !newList.includes(x))[0];
            // console.log('newKey:', newKey);

            //
            // 1. Test de la présence d'ext dans les interactions
            // Exclure ext_audio_recorder_ready car il est automatiquement ajouté
            //
            let arrReferencesFound = [];

            if (activePublication.datas.contributorInteractions?.extProfilsSelected?.includes(newKey) && newKey !== 'ext_audio_recorder_ready') {
              arrReferencesFound.push(this.translator.instant('Interactions'));
            }

            activePublication.datas.surveyConditions?.groups.forEach((aGroup) => {
              // console.log('indexOf:', aGroup.SQLRules.sqlRule.indexOf(newKey));
              if (aGroup.SQLRules.sqlRule) {
                if (aGroup.SQLRules.sqlRule?.indexOf(newKey) !== -1) {
                  arrReferencesFound.push(this.translator.instant('Conditions'));
                }
              }
            });

            activePublication.datas.quota?.groups?.forEach((aGroup) => {
              if (aGroup.completeSQLRule) {
                if (aGroup.completeSQLRule?.indexOf(newKey) !== -1) {
                  arrReferencesFound.push(this.translator.instant('Quotas'));
                }
              }
            });

            arrReferencesFound = [...new Set([...arrReferencesFound])];

            if (arrReferencesFound.length > 0) {
              return confirm(this.translator.instant(`Déselectionner le profil <b>${newKey}</b> ?<br>Il est utilisé : <br> -${arrReferencesFound.join('<br> -')}`), this.translator.instant('Confirmer la déselection')).then((dialogResult) => {
                if (dialogResult) {
                  resolve(newList);
                } else {
                  // Pas Reject mais plus repasser les ext originaux car la case se décoche 'avant' d'arriver ici....
                  resolve(currentSelectedProfiles);
                }
              });
            } else {
              //
              // Sinon tout est ok on renvoie la newList:
              // console.log('{promise} Envoyer newList - pas de pb rencontré');
              resolve(newList);
              //
            }
          }

          //
          // Dans le doute on va renvoyer l'ancienne liste :)
          //
          resolve(currentSelectedProfiles || newList);
          //
          //

        } catch (e) {
          console.log('promiseResult', e);
          reject(e);
        }

      });
    };

    return from(promiseResult({newList, activePublication}));
  }
}
